export const VALIDATION_MESSAGES = {
  STORE_NAME_REQUIRED: 'Store Name is required',
  CATEGORY_REQUIRED: 'At least one category is required',
  SCHEDULE_REQUIRED: 'At least one schedule is required',
  INVALID_EMAIL: 'Please enter a valid email address',
} as const;

export const PLACEHOLDERS = {
  STORE_NAME: 'Enter store name (e.g., Downtown Location)',
  SEARCH_CATEGORIES: 'Search and select categories',
  SELECT_SCHEDULES: 'Select schedules...',
} as const;

export const MESSAGES = {
  STORE_CREATED: 'Store Created Successfully! 🎉',
  STORE_UPDATED: 'Store Updated Successfully! 🚀',
  STORE_DELETED: 'Store Deleted Successfully! 🗑️',
  DELETE_CONFIRMATION: 'Are you sure you want to delete this store? This action cannot be undone and will permanently remove all associated data.',
  NO_STORES: 'No stores found',
  GET_STARTED: 'Get started by creating your first store location',
  NO_CATEGORIES: 'No categories selected. Select categories to organize your store.',
  NO_SCHEDULES: 'No schedules selected.',
  REQUIRED_FIELDS_NOTE: 'Note: Only Store Name, Categories, and Schedules are required. Address and contact details are optional.',
} as const;

export const LABELS = {
  STORE_NAME: 'Store Name',
  STORE_ADDRESS: 'Store Address',
  STORE_CATEGORIES: 'Store Categories',
  STORE_SCHEDULES: 'Store Schedules',
  SELECTED_CATEGORIES: 'Selected Categories',
  SELECTED_SCHEDULES: 'Selected Schedules',
  CREATE_STORE: 'Create Store',
  UPDATE_STORE: 'Update Store',
  DELETE_STORE: 'Delete Store',
  EDIT_STORE: 'Edit Store',
  CANCEL: 'Cancel',
  SAVE: 'Save Changes',
  CREATE: 'Create',
  UPDATE: 'Update',
  DELETE: 'Delete',
  REFRESH: 'Refresh',
  LAST_UPDATED: 'Last Updated',
  TOTAL_STORES: 'Total Stores',
  WITH_ADDRESS: 'With Address',
  CATEGORIZED: 'Categorized',
  STORES_MANAGEMENT: 'Stores Management',
} as const;

export const FILE_CONSTRAINTS = {
  MAX_IMAGE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
} as const;
